module.exports = __webpack_public_path__ + "static/media/head.b9da7ba4.png";